import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Stack from '@mui/material/Stack'
import Avatar from '@mui/material/Avatar'
import {classes, StyledDivider} from '../PersonaSummary/SummaryComponentStyles'
import CustomBox from '../../common/CustomBox'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import {classesIP} from './selectedPersonaStyles'
import {getPersonaCustomName} from '../../Dashboard/helper'
import {useConfig} from '../../../store/hooks/config'

const PersonaHeader = ({personaSidebarOpen, filteredPersonaDesc, setPersonaSidebarOpen}) => {
  const {personasConfig} = useConfig()
  return (
    <>
      <CustomBox className={classesIP.personaHCB}>
        <Stack alignItems='center' direction='row' gap={1} className={classesIP.personaCustomBox}>
          <BadgeOutlinedIcon className={classesIP.personaIcon} />
          <Typography
            className={classesIP.personaSubTitle}
            variant='overline'
            tabIndex={0}
            aria-label={`No ${personaSidebarOpen?.value + 1} Persona in this area`}
          >
            #{personaSidebarOpen?.value + 1} Persona in this area
          </Typography>
        </Stack>

        <Box>
          <IconButton
            id='close-sidebar'
            aria-label='close sidebar'
            className={classes.closeButton}
            onClick={() => {
              setPersonaSidebarOpen({...personaSidebarOpen, open: !personaSidebarOpen.open})
              document.getElementById('persona-list-panel')?.focus({preventScroll: true})
            }}
            size='large'
            tabIndex={0}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </CustomBox>
      <Stack
        alignItems='center'
        direction='row'
        gap={1}
        className={[classes.summaryTitleColorTeal, classesIP.personaHeaderStack]}
      >
        {filteredPersonaDesc[0]?.name && (
          <Avatar
            alt={filteredPersonaDesc[0]?.name}
            src={require(`../../../icons/Personas/${filteredPersonaDesc[0]?.name}.jpg`)}
            sx={{width: 80, height: 80}}
          />
        )}
        <Stack className={classesIP.personaHeaderStackMargin} alignItems='start' direction='column' tabIndex={0}>
          <Typography className={classesIP.personaTitle}>
            {getPersonaCustomName(filteredPersonaDesc[0]?.name, personasConfig)}
          </Typography>
          <Typography className={classesIP.personaStackSubTitle2}>{filteredPersonaDesc[0]?.cohort}</Typography>
        </Stack>
      </Stack>

      <StyledDivider />
    </>
  )
}
PersonaHeader.propTypes = {
  personaSidebarOpen: PropTypes.object.isRequired,
  filteredPersonaDesc: PropTypes.array.isRequired,
  setPersonaSidebarOpen: PropTypes.func
}

export default PersonaHeader
